import React, { useEffect } from "react";
import "./Change_Bank_Name.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Form } from "react-bootstrap";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { GetAllBanks } from "../../features/wallet/slice";
import { SubmitChangeBankName } from "../../features/support/slice";

function Change_Bank_Name() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      bank_id: null,
      correct_bank_name: "",
    },
  });

  const allBanks = useSelector((state) => state.wallet.banks);

  useEffect(() => {
    dispatch(GetAllBanks({}));
  }, [dispatch]);

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(
        SubmitChangeBankName({
          bank_id: data.bank_id?.value,
          bank_number: data.bank_id?.account_number,
          bank_name: data.correct_bank_name.trim(),
        })
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage(res?.payload?.data);
        setModalShow(true);
        reset();
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 2000);
      } else {
        setModalMessage(
          res?.payload?.errors || "Submission failed. Please try again"
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }
    } catch (error) {
      console.error("Change Bank Name Error:", error);
    }
  };

  return (
    <>
      <section className="Change_Login_Password login-page">
        <Common_white_header headingText={"Change Bank Name"} />

        <div className="container">
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* ── Select Bank (Dropdown) ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Bank Account Number <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Controller
                name="bank_id"
                control={control}
                rules={{ required: "Bank is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    placeholder="Select Bank"
                    options={allBanks?.map((bank) => ({
                      value: bank?.id,
                      label: `${bank?.bank_name} - ${bank?.account_number}`,
                      account_number: bank?.account_number,
                    }))}
                  />
                )}
              />
              {errors.bank_id && (
                <small className="text-danger">{errors.bank_id.message}</small>
              )}
            </Form.Group>

            {/* ── Correct Bank Name (Text Input) ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Correct Bank Name <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Correct Bank Name"
                {...register("correct_bank_name", {
                  required: "Bank name is required",
                  minLength: {
                    value: 3,
                    message: "Name must be at least 3 characters",
                  },
                  maxLength: {
                    value: 50,
                    message: "Name cannot exceed 50 characters",
                  },
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message: "Name can only contain letters and spaces",
                  },
                })}
              />
              {errors.correct_bank_name && (
                <small className="text-danger">
                  {errors.correct_bank_name.message}
                </small>
              )}
            </Form.Group>

            {/* ── Submit ── */}
            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>
        </div>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Change_Bank_Name;